import { render, staticRenderFns } from "./SyllablesTestContainer.vue?vue&type=template&id=501851c6&scoped=true"
import script from "./SyllablesTestContainer.vue?vue&type=script&lang=ts"
export * from "./SyllablesTestContainer.vue?vue&type=script&lang=ts"
import style0 from "./SyllablesTestContainer.vue?vue&type=style&index=0&id=501851c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501851c6",
  null
  
)

export default component.exports